import { useMemo } from 'react';
import { pick } from 'lodash';

const fallbackValues = {
	email: '',
};

const useForgottenPasswordFormInitialValues = data =>
	useMemo(
		() => ({
			...fallbackValues,
			...pick(data, ['email']),
		}),
		[data],
	);

export default useForgottenPasswordFormInitialValues;
